<script>
  import Button from '@components/Button.svelte';
  import Link from '@components/Link.svelte';

  export let mobile = false;
</script>

<style style="text/scss" lang="scss">
  .invite-congrats {
    .invite-background {
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      border: 0px;
      z-index: -1;
      height: 100%;
    }

    .similing-face {
      margin-top: 40px;
    }

    .ui-header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      margin-top: 25px;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }

    .ui-subheader {
      margin-top: 16px;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #7f7f7f;
      max-width: 410px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .mobile {
    padding: 30px;

    .invite-background {
      height: 100%;
      width: 100%;
    }
  }
</style>

<div class="invite-congrats" class:mobile={mobile}>
  <img
    src="/images/app-invites/{mobile ? 'congrats-background-mobile.png' : 'congrats-background.png'}"
    class="invite-background" />

  <div class="similing-face">
    <img src="/images/app-invites/clapping-hands.svg" />
  </div>

  <div class="ui-header">Thank you!</div>
  <div class="ui-subheader">
    <div style="margin-top: 10px;">
      We’ll read your note and be in touch very soon. We can’t wait to have you check out Benable!
    </div>
    <div style="margin-top: 20px;">
      In the meantime, you can follow us on <Link
        href="https://instagram.com/benable_hq"
        text="Instagram"
        newTab={true} /> where we often share invite codes.
    </div>
  </div>

  <div style="position: absolute; bottom: 64px; width: 180px; left: calc(50% - 90px);">
    <Button
      on:click={() => {
        location.href = '/';
      }}
      text="Go to the Homepage" />
  </div>
</div>
